import { type FC } from 'react'

import { useMutation } from '@apollo/client'
import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  DeleteItManagementDocumentTemplateDocument,
  ItManagementDocumentTemplatesListDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface DeleteTemplateModalProps {
  template: {
    id: string
    title: string
  }
  onClose: () => void
}

export const DeleteTemplateModal: FC<DeleteTemplateModalProps> = ({ template, onClose }) => {
  const [deleteTemplate, { loading }] = useMutation(DeleteItManagementDocumentTemplateDocument, {
    refetchQueries: [ItManagementDocumentTemplatesListDocument],
    onCompleted: () => {
      onClose()
    },
  })

  const handleDelete = () => {
    deleteTemplate({
      variables: {
        id: template.id,
      },
    })
  }

  return (
    <Modal
      data-testid="delete-template-modal"
      title={i18n.t('it_management.settings.document_templates.delete_modal.title')}
      onClose={onClose}
      illustration="delete-cross"
      description={i18n.t('it_management.settings.document_templates.delete_modal.description', {
        name: template.title,
      })}
      onSubmit={handleDelete}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose} disabled={loading}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" submit disabled={loading}>
            {loading ? i18n.t('common.deleting') : i18n.t('common.destroy')}
          </Button>
        </Box>
      }
    />
  )
}
